NtechApp.SchedulesGridControls = function($view) {
    var me = this;

    this._$view = null;

    this._click = null;
    this._ajax = null;
    //this._loader = null;
    //this._overlay = null;

    this._construct = function() {
        me._$view = $view;

        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();
        //me._loader = new NtechApp.Loader();
        //me._overlay = new NtechApp.Overlay();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-toggleScheduleStatus]", function(event) {
            var $button = $(event.target);
            var modelId = $button.attr("data-toggleScheduleStatus");

            me._toggleStatus.call(me, modelId, $button);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.SchedulesGridControls.EVENT_SCHEDULE_REMOVE = "NtechApp.SchedulesGridControls.EventScheduleRemove";

NtechApp.proto(NtechApp.SchedulesGridControls, {
    _enableLoader: function() {
        this._loader.on();
        this._overlay.on();
    },

    _disableLoader: function() {
        this._loader.off();
        this._overlay.off();
    },

    // @todo -> rename to rm
    _toggleStatus: function(modelId, $button) {
        var me = this;
        //this._enableLoader();

        NtechApp.confirmForm.load(function() {
            me._ajax.post({
                url: Routing.generate("business_schedule_toggle_status"),
                data: {modelId: modelId},
                onSuccess: function (data) {
                    me._updateStatusView($button);

                    NtechApp.info.on("Schedule successfully removed.", 3500);
                    NtechApp.confirmForm.unload();

                    $(me).trigger(NtechApp.SchedulesGridControls.EVENT_SCHEDULE_REMOVE, [
                        modelId, data.teamNotificationId
                    ]);
                },
                onComplete: function () {
                    //me._disableLoader();
                }
            });
        });
    },

    _updateStatusView: function($status, wasEnabled) {
        var $schedule = $status.closest("[data-schedule]");
        $schedule.remove();

        var $count = $("body").find("[data-schedulesCount]");
        var newVal = parseInt($count.text(), 10) - 1;
        if(newVal < 0)
            newVal = 0;

        $count.text(newVal);
        // var $activity = $schedule.find("[data-scheduleActivity]");

        // if(wasEnabled) {
        //     $status.text("Stop");
        //     $activity.text("Active");
        // }
        // else {
        //     $status.text("Post");
        //     $activity.text("Inactive");
        // }
    }
});